import moment from "moment"

const config = {
  url: '/event/:id',
  getTitle: id => id === 'create' ? 'Создание события' : 'Редактирование события',
  getApiUrl: id => id === 'create' ? '/events' : `/events/${id}`,
  type: 'card',
  access: ['*'],
  tabs: [
    {
      key: 'common',
      title: 'Общее',
      children: {
        left: [
          {
            key: 'title',
            title: 'Название',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 100,
            required: true,
          },
          {
            key: 'subtitle',
            title: 'Подзаголовок',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 100,
            required: false,
          },
          {
            key: 'event_type_id',
            title: 'Тип события',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=event_types&sort[field]=name&sort[type]=asc&limit=100',
            disableFilterByValue: true,
            filter: 'event_types',
            keyName: 'event_types_name',
            placeholder: 'Выберите тип',
            search: true,
            mode: 'single',
            getOptionValue: data => data.name,
            required: true,
            relatedCard: '/event-type/:id',
          },
          {
            key: 'location_id',
            title: 'Площадка',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=locations&sort[field]=name&sort[type]=asc&limit=100',
            disableFilterByValue: true,
            filter: 'locations',
            keyName: 'locations_name',
            placeholder: 'Выберите',
            search: true,
            mode: 'single',
            getOptionValue: data => data.name,
            required: false,
            relatedCard: '/location/:id',
            allowClear: true,
          },
          {
            key: 'festival_id',
            title: 'Фестиваль',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=festivals&sort[field]=name&sort[type]=asc&limit=100',
            disableFilterByValue: true,
            filter: 'festivals',
            keyName: 'festivals_name',
            placeholder: 'Выберите',
            search: true,
            mode: 'single',
            getOptionValue: data => data.name,
            required: true,
            relatedCard: '/festival/:id',
          },
          {
            key: 'date_s',
            title: 'Дата начала',
            component: 'Date',
            placeholder: 'Введите',
            showTime: false,
            format: 'YYYY-MM-DD',
            style: { width: '100%' },
            defaultValue: moment().format('YYYY-MM-DD'),
            getValue: data => moment(data.date_s, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            required: true,
          },
          {
            key: 'date_e',
            title: 'Дата окончания',
            component: 'Date',
            placeholder: 'Введите',
            showTime: false,
            format: 'YYYY-MM-DD',
            style: { width: '100%' },
            defaultValue: moment().format('YYYY-MM-DD'),
            getValue: data => moment(data.date_e, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            required: true,
          },
          {
            key: 'science_organization_ids',
            title: 'Научные организации',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=science_organizations&sort[field]=title&sort[type]=asc&limit=100',
            filter: 'science_organizations',
            disableFilterByValue: true,
            placeholder: 'Выберите организации',
            search: true,
            mode: 'multiple',
            getOptionValue: data => data.title,
            required: false,
            relatedCard: '/science-organization/:id',
          },
          {
            key: 'link',
            title: 'Ссылка',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
          },
          {
            key: 'color',
            title: 'Цвет (RGB)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 6,
            required: false,
          },
          {
            key: 'persons_for_card',
            title: 'Персоны для карточки',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
          },
          {
            key: 'person_ids',
            title: 'Персоны',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=persons&sort[field]=surname&sort[type]=asc&limit=50',
            filter: 'persons',
            placeholder: 'Выберите персоны',
            search: true,
            mode: 'multiple',
            getOptionValue: data => data.surname + ' ' + data.name,
            required: false,
            relatedCard: '/person/:id',
          },
          {
            key: 'partner_ids',
            title: 'Партнеры',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=partners&sort[field]=name&sort[type]=asc&limit=50',
            filter: 'partners',
            placeholder: 'Выберите партнеров',
            search: true,
            mode: 'multiple',
            getOptionValue: data => data.name,
            required: false,
            relatedCard: '/partner/:id',
          },
          {
            key: 'tag_ids',
            title: 'Теги',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=tags&sort[field]=name&sort[type]=asc&limit=200',
            disableFilterByValue: true,
            filter: 'tags',
            placeholder: 'Выберите теги',
            search: true,
            mode: 'multiple',
            getOptionValue: data => data.name,
            required: false,
            relatedCard: '/tag/:id',
          },
          {
            key: 'is_show_in_slider',
            title: 'Показывать в слайдере',
            component: 'Switch',
            defaultValue: 0,
          },
          {
            key: 'show_on_main_page',
            title: 'Всегда показывать на главной',
            component: 'Switch',
            defaultValue: 0,
          },
          {
            key: 'hidden',
            title: 'Скрыть',
            component: 'Switch',
            defaultValue: 0,
          },
        ],
        right: [
          {
            key: 'image_storage_id',
            title: 'Главное изображение (jpg)',
            component: 'Image',
            multiple: false,
            maxCount: 1,
            keyName: 'image_storage_id',
            keyList: 'image_storage',
            allowTypes: ['jpg'],
          },
          {
            key: 'logo_storage_id',
            title: 'Логотип (png, svg)',
            component: 'File',
            multiple: false,
            maxCount: 1,
            keyName: 'logo_storage_id',
            keyList: 'logo_storage',
            allowTypes: ['svg', 'png'],
          },
          {
            key: 'image_ids',
            title: 'Изображения (jpg)',
            component: 'Image',
            multiple: true,
            maxCount: 10,
            keyName: 'image_ids',
            keyList: 'images',
            allowTypes: ['jpg'],
          },
        ],
        both: [
          {
            key: 'short_description',
            title: 'Короткое описание',
            component: 'TextArea',
            placeholder: 'Введите текст',
            maxLength: 500,
            required: false,
          },
          {
            key: 'main_description',
            title: 'Описание',
            component: 'CKEditor',
            placeholder: 'Введите текст',
            required: false,
            isFixedHeight: false,
            height: '200px'
          },
        ],
      }
    },
    {
      key: 'common_en',
      title: 'Общее (en)',
      children: {
        left: [
          {
            key: 'title_en',
            title: 'Название (en)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 100,
            required: false,
          },
          {
            key: 'subtitle_en',
            title: 'Подзаголовок (en)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 100,
            required: false,
          },
          {
            key: 'persons_for_card_en',
            title: 'Персоны для карточки (en)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
          },
        ],
        right: [],
        both: [
          {
            key: 'short_description_en',
            title: 'Короткое описание (en)',
            component: 'TextArea',
            placeholder: 'Введите текст',
            maxLength: 500,
            required: false,
          },
          {
            key: 'main_description_en',
            title: 'Описание (en)',
            component: 'CKEditor',
            placeholder: 'Введите текст',
            required: false,
            isFixedHeight: false,
            height: '200px'
          },
        ],
      }
    },
  ]
}

export default config
